import React, { useState } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { useGame } from '../context/GameContext';
import PlayerList from '../components/PlayerList';
import './LobbyPage.css';

/**
 * Lobby page - Wait for players and start game
 */
const LobbyPage = () => {
  const { game, currentPlayer, startTheGame, leaveGame, isHost, loading } = useGame();
  const [cardsPerPlayer, setCardsPerPlayer] = useState(5);
  const [allowDuplicates, setAllowDuplicates] = useState(true);

  if (!game) return null;

  const joinUrl = `${window.location.origin}?join=${game.id}`;

  const copyGameCode = () => {
    navigator.clipboard.writeText(game.id);
    // Could add a toast notification here
  };

  return (
    <div className="lobby-page">
      <div className="lobby-container fade-in">
        {/* Header */}
        <div className="lobby-header">
          <span className="lobby-icon">🎱</span>
          <h1>Game Lobby</h1>
          <p>Waiting for players...</p>
        </div>

        {/* Game Code */}
        <div className="game-code-section">
          <span className="code-label">Game Code</span>
          <div className="code-display" onClick={copyGameCode}>
            <span className="code-value">{game.id}</span>
            <span className="copy-hint">📋 Tap to copy</span>
          </div>
        </div>

        {/* QR Code */}
        <div className="qr-section">
          <QRCodeSVG 
            value={joinUrl}
            size={140}
            bgColor="transparent"
            fgColor="#ffffff"
            level="M"
          />
          <span className="qr-hint">Scan to join</span>
        </div>

        {/* Players List */}
        <PlayerList 
          players={game.players} 
          currentPlayerId={currentPlayer?.id}
        />

        {/* Actions */}
        <div className="lobby-actions">
          {isHost ? (
            <>
              <div className="cards-per-player-section">
                <label htmlFor="cardsPerPlayer">Cards per player:</label>
                <select
                  id="cardsPerPlayer"
                  value={cardsPerPlayer}
                  onChange={(e) => setCardsPerPlayer(Number(e.target.value))}
                  className="cards-select"
                >
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(n => (
                    <option key={n} value={n}>{n}</option>
                  ))}
                </select>
              </div>
              <div className="allow-duplicates-section">
                <label htmlFor="allowDuplicates">
                  <input
                    type="checkbox"
                    id="allowDuplicates"
                    checked={allowDuplicates}
                    onChange={(e) => setAllowDuplicates(e.target.checked)}
                  />
                  Allow duplicate numbers
                </label>
                <span className="duplicates-hint">
                  {allowDuplicates ? '(Same number can appear multiple times)' : '(Each number only once - max 15 cards total)'}
                </span>
              </div>
              <button 
                className="btn btn-primary start-btn"
                onClick={() => startTheGame(cardsPerPlayer, allowDuplicates)}
                disabled={game.players.length < 2 || loading}
              >
                {loading ? 'Starting...' : `🎱 Start Game (${game.players.length} players)`}
              </button>
              {game.players.length < 2 && (
                <p className="min-players-hint">Need at least 2 players to start</p>
              )}
            </>
          ) : (
            <p className="waiting-hint">Waiting for host to start the game...</p>
          )}
          
          <button className="btn btn-secondary" onClick={leaveGame}>
            🚪 Leave Game
          </button>
        </div>
      </div>
    </div>
  );
};

export default LobbyPage;


